import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosRequestHeaders,
  AxiosResponse,
  AxiosError
} from 'axios'

import qs from 'qs'

import { config } from './config'

import { useAppStore } from '@/store/modules/app'

import { useCache } from '@/hooks/web/useCache'
import { showErrorToast, parseAxiosError } from '@/utils/errorHandler'

const { wsCache } = useCache()

const { result_code, base_url } = config

export const PATH_URL = base_url[import.meta.env.VITE_API_BASEPATH]

const dateTransformer = (data: unknown): unknown => {
  if (data instanceof Date) {
    // do your specific formatting here
    return data.toLocaleString()
  }
  if (Array.isArray(data)) {
    return data.map((val) => dateTransformer(val))
  }
  if (typeof data === 'object' && data !== null) {
    return Object.fromEntries(
      Object.entries(data as Record<string, unknown>).map(([key, val]) => [key, dateTransformer(val)])
    )
  }
  return data
}
// 创建axios实例
const service: AxiosInstance = axios.create({
  baseURL: PATH_URL, // api 的 base_url
  timeout: config.request_timeout, // 请求超时时间
  transformRequest: [dateTransformer].concat(axios.defaults.transformRequest)
})

// request拦截器

service.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    if (
      config.method === 'post' &&
      (config.headers as AxiosRequestHeaders)['Content-Type'] ===
      'application/x-www-form-urlencoded'
    ) {
      config.data = qs.stringify(config.data)
    }
    const appStore = useAppStore()
    // const userInfo = await wsCache.get(appStore.getUserInfo)
    const userInfo = appStore?.getUserInfo?.token

    if (userInfo) {
      ; (config.headers as AxiosRequestHeaders)[
        'Authorization'
      ] = `${userInfo.type} ${userInfo.token}`
    }
    // get参数编码
    if (config.method === 'get' && config.params) {
      let url = config.url as string
      url += '?'
      const keys = Object.keys(config.params)
      for (const key of keys) {
        if (config.params[key] !== void 0 && config.params[key] !== null) {
          url += `${key}=${encodeURIComponent(config.params[key])}&`
        }
      }
      url = url.substring(0, url.length - 1)
      config.params = {}
      config.url = url
    }
    return config
  },
  (error: AxiosError) => {
    // Do something with request error
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  (response: AxiosResponse<unknown>) => {
    if (response.config.responseType === 'blob') {
      // 如果是文件流，直接过
      return response
    } else {
      return response.data
    }
  },
  async (error: AxiosError) => {
    // 解析錯誤信息
    const errorInfo = parseAxiosError(error)

    if (error.response) {
      const { status } = error.response

      if (status === 401) {
        const appStore = useAppStore()
        // 未授权，清除用户信息並跳转到登录页
        await appStore.clearStore()
        // 顯示錯誤訊息
        await showErrorToast(errorInfo.message)
        location.href = '/login'
      } else {
        // 其他錯誤：顯示用戶友好的錯誤訊息
        console.error(`[API Error ${status}]:`, errorInfo.message, error)
        await showErrorToast(errorInfo.message)
      }
    } else if (error.request) {
      // 請求已發出但沒有收到響應（網路問題）
      console.error('[Network Error]:', errorInfo.message)
      await showErrorToast(errorInfo.message)
    } else {
      // 請求配置出錯
      console.error('[Request Config Error]:', errorInfo.message)
      await showErrorToast(errorInfo.message)
    }

    return Promise.reject(error)
  }
)

export { service }
